import { Button } from "@amzn/storm-ui";
import { isEmpty } from "lodash";
import * as React from "react";
import { useStore } from "zustand";

import { useCreateInsightLinkageAndDownload } from "../../hooks/insightLinkage/useCreateInsightLinkageAndDownload";
import { useAsyncErrorStatusNotification } from "../../hooks/notifications/useAsyncErrorStatusNotification";
import { csatFeedbackStore } from "../../store/csatFeedback";
import { InsightLinkageStore } from "../../store/insightLinkage";
import { isLoading } from "../../utils/api.utils";
import {
    DivFlexJustifyRight,
    ModalFooterCancelButton,
    ModalFooterContainer,
} from "../common/styled.components";

export const InsightLinkageFooter: React.FunctionComponent = () => {
    const [sfObject, insightLinkageMetadata, resetInsightLinkage] = useStore(
        InsightLinkageStore,
        (state) => [
            state.sfObject,
            state.insightLinkageMetadata,
            state.resetInsightLinkage,
        ],
    );

    const {
        title,
        content,
        insightType,
        identifier,
        downloadUrl,
        description,
        contentId,
        contentVersion,
    } = insightLinkageMetadata;

    const [insightLinkageState, insightLinkageAction] =
        useCreateInsightLinkageAndDownload();
    useAsyncErrorStatusNotification(insightLinkageState, [], {
        Error: "Your salesforce association failed. If issue persists, please Report an issue",
    });

    const [setIsEligibleToProvideFeedback] = useStore(
        csatFeedbackStore,
        (state) => [state.setHasUserPerformedActionWorthFeedback],
    );

    const handleDownload = async () => {
        await insightLinkageAction.execute({
            title,
            content,
            insightType,
            identifier,
            downloadUrl,
            description,
            contentId,
            contentVersion,
        });
        setIsEligibleToProvideFeedback(true);
    };

    return (
        <ModalFooterContainer>
            <ModalFooterCancelButton
                onClick={() => resetInsightLinkage()}
                data-testid="insight-linkage-reset"
            >
                Cancel
            </ModalFooterCancelButton>
            <br />
            <DivFlexJustifyRight>
                <Button
                    loading={isLoading(insightLinkageState.status)}
                    data-testid="create-insight-linkage"
                    type="submit"
                    variant="primary"
                    onClick={() => void handleDownload()}
                    disabled={isEmpty(sfObject.sfObjectId)}
                >
                    Apply & download insight
                </Button>
            </DivFlexJustifyRight>
        </ModalFooterContainer>
    );
};
